"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationSearchContainerComponent = TranslationSearchContainerComponent;
const React = __importStar(require("react"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const GraphQLQuery = __importStar(require("@genesys/client-core/lib/graphql-query"));
const Actions = __importStar(require("./actions"));
const search_inputs_component_1 = require("./search-inputs-component");
const result_component_1 = require("./result-component");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const queryProduct = (0, graphql_tag_1.default) `
  query TranslationSearchLanguagesQuery {
    product {
      languages {
        id
      }
    }
  }
`;
function TranslationSearchContainerComponent(props) {
    return (React.createElement(GraphQLQuery.QueryProductSimple, { query: queryProduct, variables: {} }, ({ product: { languages } }) => (React.createElement(Elements.ScrollContainer, null,
        React.createElement(Elements.FlexContainerRowWithPadding, null,
            React.createElement(Elements.H2, null, "Translation Search")),
        React.createElement(search_inputs_component_1.SearchInputsComponent, { searchInputState: props.searchInputState, languages: languages, dispatch: props.dispatch }),
        React.createElement(Elements.FlexContainerRowWithPadding, null,
            React.createElement(Elements.StandardButton, { disabled: props.searchInputState.searchBoxState.searchValue.trim()
                    .length === 0, onClick: () => props.dispatch(Actions.onSearch({})) }, "Go")),
        React.createElement(ResultWrapper, Object.assign({}, props))))));
}
function ResultWrapper(props) {
    if (!props.canSearch) {
        return null;
    }
    return (React.createElement(Elements.FlexContainerRowWithPadding, null,
        React.createElement(result_component_1.ResultComponent, { languageCodes: props.searchSelections.selectedLanguages, translation: props.searchSelections.searchValue.trim() })));
}
//# sourceMappingURL=container-component.js.map